import { Table } from 'ui/table';
import { PaginationFooter } from 'ui/paginationFooter';
import { useClientPaginatedState } from 'ui/table/hooks/useClientPaginatedState';
import { TableHeader } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { AUTHED_EMAILS_TABLE_COLUMNS } from '../constants';
import type { AuthedEmailTableProps } from '../types';

export const AuthedEmailsTable = ({ authedEmails }: AuthedEmailTableProps) => {
  const {
    currentPage,
    itemsPerPage,
    numItems,
    rows,
    setCurrentPage,
    setItemsPerPage,
    setSortDirection,
    setSortedBy,
    sortDirection,
    sortedBy,
  } = useClientPaginatedState({
    rows: authedEmails,
    sortedBy: 'email',
  });

  return (
    <>
      <Table data-test="senders-authed-emails-table">
        <TableHeader
          columns={AUTHED_EMAILS_TABLE_COLUMNS}
          setSortDirection={setSortDirection}
          setSortedBy={setSortedBy}
          sortDirection={sortDirection}
          sortedBy={sortedBy}
        />
        <TableRows idKey="email" rows={rows} columns={AUTHED_EMAILS_TABLE_COLUMNS} />
      </Table>
      <PaginationFooter
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        numItems={numItems}
        onUpdate={({ page, pageSize }) => {
          setCurrentPage(page);
          setItemsPerPage(pageSize);
        }}
      />
    </>
  );
};
